import styles from "./policy.module.css";

const CookiePolicy = () => {
    return (
        <div className={styles["terms-container"]}>
            <h1>COOKIES POLICY</h1>

            <p style={{ fontFamily: "Comfortaa", fontSize: "16px" }}>
                <strong>What are cookies and what does this policy cover?</strong>
                <br />
                Cookies are small pieces of text used to store information in web browsers. Cookies are used
                to store and receive identifiers and other information on computers, phones, and other devices.
                Other technologies, including data that we store on your web browser or device, identifiers
                associated with your device and other software, are used for similar purposes. In this policy,
                we refer to all these technologies as “cookies”. If you are using Sekeron, you accept the Cookies
                policy of Sekeron.
                <br />
                This policy explains how we use cookies and the choices you have. Except as otherwise stated
                in this policy, the privacy policy will apply to our processing of the data that we collect via cookies.
            </p>

            <h2>Why do we use Cookies?</h2>
            <p>
                Cookies help us provide, protect, and improve our service, such as by personalizing content,
                tailoring, and measuring ads, and providing a safer experience. Currently, Sekeron is using only
                ‘JWT’ Cookie. The cookies that we use and how we use them may change over time as we improve,
                we typically use them for the following purposes:
            </p>
            <ul>
                <li>
                    <strong>Authentication:</strong> We use cookies to verify your account and determine when you’re logged in so that we
                    can make it easier for you to access our platform and show you the appropriate
                    experience and features. For example, we use cookies to keep you logged in as you navigate
                    between projects on Sekeron. Cookies also help us remember your browser so you don’t
                    have to keep logging in to Sekeron and so you can more easily log in to Sekeron via third-party apps and websites.
                </li>
                <li>
                    <strong>Security, Site and product integrity:</strong> We use cookies to help us keep your account and data safe and secure.
                    For example, cookies can help us identify and impose additional security measures when someone
                    may be attempting to access a Sekeron account without authorization, such as by rapidly guessing
                    different passwords. We also use cookies to store information that allows us to recover your account in the event
                    that you forget your password or to require additional authentication if you tell us that your account has been hacked.
                    We also use cookies to combat activity that violates our policies or otherwise degrades our ability to provide the services.
                    For example, cookies help us fight spam and phishing attacks by enabling us to identify computers that are used
                    to create large numbers of fake accounts on Sekeron. We also use cookies to detect computers infected with malware
                    and to take steps to prevent them from causing further harm.
                </li>
                <li>
                    <strong>Advertising, recommendations, insights and measurement:</strong> We use cookies to help us show ads and to make recommendations for businesses and
                    other organizations to people who may be interested in the products, services, or causes they promote. For example,
                    cookies allow us to help deliver ads to people who have previously visited a business’s website, purchased its products,
                    or used its apps, and to recommend products and services based on that activity. Cookies also allow us to limit the
                    number of times that you see an ad so you don’t see the same ad over and over again. Cookies also allow us to provide
                    insights about the people who use the Sekeron Platform, as well as the people who interact with the ads, websites,
                    and apps of our advertisers and the businesses.
                </li>
                <li>
                    <strong>Site features and services:</strong> We also use cookies to help provide you with content relevant to your locale.
                    For example, we store information in a cookie that is placed on your browser or device so that you will see the site in
                    your preferred language.
                </li>
                <li>
                    <strong>Performance:</strong> We use cookies to provide you with the best experience possible. For example, cookies help
                    us route traffic between servers and understand how quickly Sekeron loads for different people. Cookies also help us record
                    the ratio and dimensions of your screen and windows and know whether you've enabled high-contrast mode, so that we can
                    render our sites and apps correctly.
                </li>
                <li>
                    <strong>Analytics and research:</strong> We use cookies to better understand how people use Sekeron, so that we can improve them.
                </li>
                <li>
                    <strong>Third-party websites and apps:</strong> Our business partners may also choose to share information with Sekeron from cookies
                    set in their own website’s domains. Apart from others, currently Sekeron can receive information from accounts.google.com and www.google.com.
                </li>
            </ul>

            <h2>Where do we use cookies?</h2>
            <p>
                We may place cookies on your computer or device and receive information stored in cookies when you use or visit:
            </p>
            <ul>
                <li>The Sekeron platform;</li>
                <li>Websites and apps provided by other companies that use Sekeron. Sekeron uses cookies and receives information when you visit those sites and apps, including device information and information about your activity, without any further action from you.</li>
            </ul>

            <h2>Do other Companies use cookies in connection with Sekeron?</h2>
            <p>
                Yes, other companies use cookies on Sekeron to provide advertising, measurement, marketing, and analytics services to us, and to provide certain features and improve our services for you.
            </p>
        </div>

    );
}
export default CookiePolicy;